const blogPost = {
  init: function () {
    document.addEventListener('DOMContentLoaded', function () {
      const styles = {
        disabled: {
          backgroundColor: '#D9DBDA',
          textColor: '#4b4b4b',
        },
        enabled: {
          backgroundColor: '#5812CD',
          textColor: '#ffffff',
        },
      }

      const blogContent = blogPost.getBlogContent()
      if (!blogContent) return

      blogPost.setupCarousel(blogContent, 'image')
      blogPost.setupCarousel(blogContent, 'product')

      blogPost.updateDisabledButtonStyles(styles)
    })
  },

  getBlogContent: function () {
    return document.querySelector('.js-article-template__body')
  },

  setupCarousel: function (content, type) {
    const elements = content.querySelectorAll('p')
    const carousel = content.querySelector(`.js-display-${type}-carousel`)
    const placeholderText =
      type === 'image' ? '[[ CAROUSEL ]]' : '[[ PRODUCT-GRID ]]'

    if (elements.length === 0) return

    const carouselPlaceholder = Array.from(elements).find(
      (el) => el.textContent.trim() === placeholderText
    )
    if (!carouselPlaceholder || !carousel) return

    carouselPlaceholder.replaceWith(carousel)
  },

  updateButtonStyles: function (button, styles) {
    button.style.opacity = 1
    const slot = button.querySelector('slot')
    const assignedNodes = slot.assignedNodes({ flatten: true })
    const isDisabled = button.classList.contains(
      'carousel__navigation-button--disabled'
    )
    const { backgroundColor, textColor } = isDisabled
      ? styles.disabled
      : styles.enabled

    assignedNodes.forEach((node) => {
      node.style.backgroundColor = backgroundColor
      node.querySelectorAll('path').forEach((path) => {
        path.style.stroke = textColor
      })
    })
  },

  updateDisabledButtonStyles: function (styles) {
    const carousels = document.querySelectorAll(
      '.js-recent-articles-carousel, .js-image-carousel'
    )

    carousels.forEach((carousel) => {
      const buttons = carousel.shadowRoot.querySelectorAll('button')

      buttons.forEach((button) => {
        blogPost.updateButtonStyles(button, styles)

        const observer = new MutationObserver((mutationsList) => {
          for (const mutation of mutationsList) {
            if (
              mutation.type === 'attributes' &&
              mutation.attributeName === 'class'
            ) {
              blogPost.updateButtonStyles(button, styles)
            }
          }
        })

        observer.observe(button, { attributes: true })
      })
    })
  },
}

blogPost.init()
